import { module } from 'modujs'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import { DEFAULT_DURATION } from '../lib/gsap'

export default class Slider extends module {

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        this.$prev = this.$('prev')?.[0]
        this.$next = this.$('next')?.[0]
    }

    init() {

        // Swiper options
        const options = {
            modules: [ Navigation ],
            navigation: {
                prevEl: this.$prev,
                nextEl: this.$next,
            },
            pagination: false,
            slidesPerView: 'auto',
            slidesPerGroupAuto: 'auto',
            spaceBetween: 0,
            speed: 1000 * DEFAULT_DURATION,
        }

        this.swiper = new Swiper(this.$el, options)

        this.swiper.on('toEdge', () => {
            this.$prev.removeAttribute('disabled')
            this.$next.removeAttribute('disabled')
        })

        this.$prev.removeAttribute('disabled')

        // // Disable when not enough slides
        // this.swiper.on('overflow', isOverflow => {
        //     this.swiper.options = {
        //         ...options,
        //         drag: isOverflow,
        //     }
        // })

        // // Mount slider
        // this.swiper.mount()
        // this.swiper.refresh()
    }

    destroy() {
        this.swiper?.destroy()
    }
}
